// extracted by mini-css-extract-plugin
module.exports = {"calculator":"styles_calculator__hx2wP"};